import LayoutIndex from '../layout/LayoutIndex'

const lesson = {
  path: '/lesson',
  component: LayoutIndex,
  redirect: '/lesson',
  name: 'lesson',
  meta: {
    name: '课程'
  },
  children: [
    {
      path: '/lesson',
      name: 'lesson',
      component: () => import(/* webpackChunkName: "lesson" */ '../views/lesson/lesson.vue')
    },
    {
      path: '/lessonDetail/:id',
      name: 'lessonDetail',
      component: () => import(/* webpackChunkName: "lessonDetail" */ '../views/lesson/detail.vue'),
      meta: {
        name: '课程详情'
      }
    }
  ]
}
export default lesson
